export const iaoApi = () => {
    return window.location.href.includes('test') || window.location.href.includes('localhost') ? 1114 : 1074
};
